import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiList, getApiUrl } from 'src/app/core/Constants/apiList';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordValidationService {

  constructor(
    private http: HttpClient
  ) { }

  public checkToken(token: any) : Observable<any>{
    let endpoint = getApiUrl(apiList.validate.tokenCheck, token);
    return this.http.get<ApiResponse>(endpoint)
  }
  resetPassword(payload: any, id: number): Observable<any> {
    let endpoint = getApiUrl(`${apiList.validate.resetPassword}/${id}`);
    return this.http.put<ApiResponse>(endpoint, payload);
  }

}
